// @ts-check
export const getSplitAttributes = (Auth) => {
  return {
    account_type: Auth.me.accountType,
    company_id: Auth.me.companyId,
    company_name: Auth.me.companyName,
    userId: Auth.me.internalId,
  };
};
